import React from 'react';
import PropTypes from 'prop-types';
import { StyledButtonPlus, StyledIcon } from './style';

import { Plus } from '../../../../assets/images/index';

const ButtonPlus = ({ dark, className, svg, size, onClick }) => (
  <StyledButtonPlus dark={dark} onClick={onClick} className={className}>
    <StyledIcon size={size} color="light" svg={svg} />
  </StyledButtonPlus>
);

ButtonPlus.propTypes = {
  dark: PropTypes.bool,
  className: PropTypes.string,
  svg: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }),
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'sm', 'm', 'l', 'xl']),
  onClick: PropTypes.func
};

ButtonPlus.defaultProps = {
  svg: Plus,
  size: 's'
};

export default ButtonPlus;
